import axios from '../../common/utils/interceptor';
import { apiUrls } from '../../constants';
import { TaskItemStatus } from '../constants';
import { Task } from '../interfaces';
import updateTaskItem from './updateTaskItem';

export const markCurrentNonAssessmentItemDone = async (
  currentTask: Task,
  currentTaskItemIndex: number,
): Promise<void> => {
  if (!currentTask) return;

  const currentItem = currentTask.items[currentTaskItemIndex];

  const body = {
    itemId: currentItem.id,
    state: '',
    status: TaskItemStatus.COMPLETED,
  };

  // Mark current item status completed
  await axios.put(apiUrls.INITIALIZE_TASK, body);

  updateTaskItem({ ...currentItem, taskId: currentTask.id }, TaskItemStatus.COMPLETED);
};
